module.exports = __webpack_public_path__ + "img/Leading-Discussions.0f4b06f0.png";